import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useListOfProductStore } from "../../hooks/useListOfProductStore";
import { ListOfProductModal } from "./components/ListOfProductModal";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'code', label: 'Código', align:'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align:'center' },
    { type: 'text', field: 'creationDate', label: 'Fecha de creación', align:'center' },
    { type: 'text', field: 'creatorUser', label: 'Creado por', align:'center' },
    { type: 'text', field: 'total', label: 'Total', align:'center' },
    { type: 'text', field: 'quantityProducts', label: 'Cantidad de productos', align:'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const ListOfProductsView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionListProduct, getListOfProducts, deleteListOfProduct } = useListOfProductStore();

    const [loading, setLoading] = useState(false);
    const [listProducts, setListProducts] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [showModalDetail, setShowModalDetail] = useState<boolean>(false);

    useEffect(() => {
        getListOfProductsApi()
    },[])

    const getListOfProductsApi = async() => {
        try {
            setLoading(true);
            const response = await getListOfProducts();
            if(!response){
                setListProducts([]);
                setLoading(false);
                return false;
            }else{
                setListProducts(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionListProduct('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActionListProduct('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionListProduct('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected:any) => {
        setActionListProduct('detail');
        setRowSelected(rowSelected);
        setShowModalDetail(true);
    }

    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteListOfProduct(rowSelected.id)
            if(response){
                getListOfProductsApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Lista de productos123'}
                    columns={columns} 
                    loading={loading}
                    rows={listProducts || []}
                    onRowClick={() => {}}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nueva lista'}
                    onDetails={onDetails}
                    onDelete={onDelete}
                    onSearch
                    dense
                />
            </Grid>
            {
                showModal && (
                    <ListOfProductModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        storeSelected = {rowSelected}
                        liststore = {getListOfProductsApi}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}